import type { ActionHandlerOptions } from "shared-components";
// import { revalidatePath } from "next/cache";
import { redirect as navigate } from "next/navigation";
import { api } from ".";

export function actionHandler<T, K>(action: (data: T) => Promise<K>) {
  return async (payload: T, { redirect, revalidate, token }: ActionHandlerOptions = {}) => {
    api.token = token ?? null;

    const response = await action(payload);

    // if (revalidate) {
    //   revalidatePath(revalidate);
    // }

    if (redirect) {
      navigate(redirect);
    }

    return response;
  };
}
